import { TaskFilterOptions, Timestamp } from '@griply/types';

// tasksOnly is deliberate: completed habits/repeating are not painted on calendars.
// includeTaskWithAction mirrors calendarFilterOptions: completed goal/life-area
// timeslots carry an `action` and must keep painting, else filterTasksClientSide
// drops them the moment they're completed.
export const getCompletedTasksInRangeFilterOptions = (
  start: Timestamp,
  end: Timestamp,
): TaskFilterOptions[] => [
  {
    showCompleted: true,
    completedStartDate: start,
    completedEndDate: end,
    tasksOnly: true,
    includeTaskWithAction: true,
  },
];
